import { useState } from 'react';

/**
 * Custom hook for managing Approval Route state
 */
const useApprovalRoute = () => {
  const getDefaultApprovalRoute = () => ({
    preparedByName: '',
    preparedByPosition: '',
    preparedDate: '',
    preparedTime: '',
    submittedDate: '',
    submittedTime: '',
    approvedByName: '',
    approvedByPosition: '',
    approvedDate: '',
    approvedTime: '',
    primaryLocation: ''
  });

  const [approvalRoutes, setApprovalRoutes] = useState([]);
  const [currentApprovalRoute, setCurrentApprovalRoute] = useState(getDefaultApprovalRoute());
  const [editingApprovalRoute, setEditingApprovalRoute] = useState(null);

  const addApprovalRoute = () => {
    if (!currentApprovalRoute.preparedByName.trim()) {
      alert('Please enter the name of the person who prepared the document');
      return;
    }
    
    if (editingApprovalRoute) {
      setApprovalRoutes(prev => prev.map(r => 
        r.id === editingApprovalRoute.id 
          ? { ...currentApprovalRoute, id: r.id, timestamp: r.timestamp, updatedAt: new Date().toISOString() }
          : r
      ));
      setEditingApprovalRoute(null);
    } else {
      const newRoute = {
        ...currentApprovalRoute,
        id: Date.now().toString(),
        timestamp: new Date().toISOString()
      };
      setApprovalRoutes(prev => [...prev, newRoute]);
    }
    
    setCurrentApprovalRoute(getDefaultApprovalRoute());
  };

  const editApprovalRoute = (route) => {
    setCurrentApprovalRoute({
      preparedByName: route.preparedByName || '',
      preparedByPosition: route.preparedByPosition || '',
      preparedDate: route.preparedDate || '',
      preparedTime: route.preparedTime || '',
      submittedDate: route.submittedDate || '',
      submittedTime: route.submittedTime || '',
      approvedByName: route.approvedByName || '',
      approvedByPosition: route.approvedByPosition || '',
      approvedDate: route.approvedDate || '',
      approvedTime: route.approvedTime || '',
      primaryLocation: route.primaryLocation || ''
    });
    setEditingApprovalRoute(route);
  };

  const cancelEditApprovalRoute = () => {
    setCurrentApprovalRoute(getDefaultApprovalRoute());
    setEditingApprovalRoute(null);
  };

  const deleteApprovalRoute = (routeId) => {
    if (window.confirm('Are you sure you want to delete this approval route?')) {
      setApprovalRoutes(prev => prev.filter(r => r.id !== routeId));
    }
  };

  return {
    // State
    approvalRoutes,
    setApprovalRoutes,
    currentApprovalRoute,
    setCurrentApprovalRoute,
    editingApprovalRoute,
    setEditingApprovalRoute,
    // Functions
    addApprovalRoute,
    editApprovalRoute,
    cancelEditApprovalRoute,
    deleteApprovalRoute,
    getDefaultApprovalRoute
  };
};

export default useApprovalRoute;
